import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/dashboard/Dashboard';
import Funnels from './pages/dashboard/Funnels';
import FunnelEditor from './pages/editor/FunnelEditor';
import PublicFunnel from './pages/public/PublicFunnel';
import Landing from './pages/landing/index';
import Account from './pages/dashboard/Account';
import Leads from './pages/dashboard/Leads';
import PreviewFunnel from './pages/public/PreviewFunnel';
 
 
 
 

function App() {
  return (
    <BrowserRouter>
      <Routes>
     
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
    
        

        <Route path="*" element={<Navigate to="/dashboard" replace />} /> {/* rota catch-all */}
        <Route path="/dashboard/editor/:id" element={<FunnelEditor />} />
        <Route path="/:id" element={<PublicFunnel   />} />
        <Route path="/preview/:id" element={<PreviewFunnel   />} />
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
